import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaClock, FaPaperPlane } from 'react-icons/fa';
import '../styles/ContactPage.css';

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic here
    console.log('Form submitted');
  };

  return (
    <div className="contact-page">
      {/* Header Section */}
      <section className="about-header text-center py-5 bg-navy text-white">
                <div className="container " style={{marginTop:"60px"}}>
                        <div className="d-inline-flex align-items-center gap-3 mb-3">
                          <div>
                            <h1 className="h2 fw-bold">
                               <span className="p-2 rounded-lg infra-icon-box me-2">
                            <FaPhone />
                          </span>
                              Contact <span className="highlight">Us</span>
                            </h1>
                            <p className="text-light sub-tittle mb-0">
                              Have questions? We are here to help you with your paper board needs
                            </p>
                          </div>
                        </div>
                      </div>
            </section>
            
      {/* Contact Form & Info Section */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4 g-lg-5">
            
            {/* Left Column: Contact Information - Fixed for Responsiveness */}
            <div className="col-lg-5">
              <div className="contact-info-card p-4 rounded shadow-sm bg-light h-100">
                <h3 className="fw-bold text-navy mb-4">Get In Touch</h3>
                
                {/* Responsive Contact Item - Stack on small screens */}
                <div className="contact-item-responsive mb-4">
                  <div className="d-flex align-items-start mb-2">
                    <div className="contact-icon-box me-3 flex-shrink-0">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="fw-bold mb-1">Our Location</h5>
                    </div>
                  </div>
                  <div className="contact-content-responsive">
                    <p className="text-muted mb-0">
                      No: 2/357, Thulukkankuruchi <br /> Vembakottai (T.K),<br />
                      Sivakasi - 626140,<br/>
                      Virudhunagar - District <br/>
                      Tamil Nadu.
                    </p>
                  </div>
                </div>

                {/* Phone - Better layout for small screens */}
                <div className="contact-item-responsive mb-4">
                  <div className="d-flex align-items-center mb-2">
                    <div className="contact-icon-box me-3 flex-shrink-0">
                      <FaPhone />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="fw-bold mb-0">Phone Number</h5>
                    </div>
                  </div>
                  <div className="contact-content-responsive">
                    <a href="tel:+919787182226" className="text-muted text-decoration-none d-inline-block py-1 px-2">
                      +91 97871 82226
                    </a>
                  </div>
                </div>

                {/* Email - Special handling for long email */}
                <div className="contact-item-responsive mb-4">
                  <div className="d-flex align-items-start mb-2">
                    <div className="contact-icon-box me-3 flex-shrink-0">
                      <FaEnvelope />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="fw-bold mb-1">Email Address</h5>
                    </div>
                  </div>
                  <div className="contact-content-responsive">
                    <a 
                      href="mailto:srikrishnahitechpaperboard@gmail.com" 
                      className="text-muted text-decoration-none email-link"
                    >
                      srikrishnahitechpaperboard@gmail.com
                    </a>
                  </div>
                </div>

                {/* Office Hours */}
                <div className="contact-item-responsive">
                  <div className="d-flex align-items-center mb-2">
                    <div className="contact-icon-box me-3 flex-shrink-0">
                      <FaClock />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="fw-bold mb-0">Office Hours</h5>
                    </div>
                  </div>
                  <div className="contact-content-responsive">
                    <p className="text-muted mb-0">24 X 7</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="col-lg-7">
              <div className="contact-form-wrapper p-4 border rounded shadow-sm bg-white">
                <h3 className="fw-bold text-navy mb-4">Send Us a Message</h3>
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Your Name</label>
                      <input type="text" className="form-control" placeholder="Enter name" required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Email Address</label>
                      <input type="email" className="form-control" placeholder="Enter email" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-semibold">Subject</label>
                      <input type="text" className="form-control" placeholder="Product Inquiry" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-semibold">Message</label>
                      <textarea className="form-control" rows="5" placeholder="How can we help you?" required></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-orange w-100 py-3 fw-bold">
                        <FaPaperPlane className="me-2" />
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Map Section - Full Width */}
      <section className="container-fluid p-0 mt-4">
        <div className="map-container" style={{ height: '450px', width: '100%' }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3937.436549257153!2d77.73762597478404!3d9.294530490777758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06b90030a0b2f9%3A0x699a162b49e22e69!2sSri%20Krishna%20Hi-Tech%20Paper%20Board!5e0!3m2!1sen!2sin!4v1769674338854!5m2!1sen!2sin" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Sri Krishna Hi-Tech Paper Board Location"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;